import { Bell } from 'lucide-react';

const Header = ({ title, subtitle }) => {
  return (
    <div className="sticky top-0 z-40 h-16 bg-white/80 backdrop-blur-md border-b border-slate-100 px-8 flex items-center justify-between">
      <div>
        {title && <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">{title}</h1>}
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-4">
        <button
          data-testid="notifications-button"
          className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-slate-50 transition-colors relative"
        >
          <Bell className="w-5 h-5 text-slate-600" strokeWidth={1.5} />
          <span className="absolute top-2 right-2 w-2 h-2 bg-orange-500 rounded-full"></span>
        </button>
      </div>
    </div>
  );
};

export default Header;